<template>
  <div>
    <div class="contents">
      <b-form @submit="onSubmit">
        <div class="filter-box-6">
          <div>
            <select class="form-select-lg" v-model="searchData.platform_type">
              <option value="">{{ $t("filter.common.total") }}</option>
              <option value="0">{{ $t("text.common.online") }} {{ $t("title.common.location") }}</option>
              <option value="1">{{ $t("text.common.offline") }} {{ $t("title.common.location") }}</option>
            </select>
          </div>
          <div>
            <select class="form-select-lg" v-model="searchData.ownertype">
              <option value="0">{{ $t("filter.common.total") }}</option>
              <option value="1">{{ $t("filter.membership.franchise") }}</option>
              <option value="2">
                {{ $t("filter.membership.direct_owned") }}
              </option>
            </select>
          </div>
          <div>
            <select class="form-select-lg" v-model="searchData.status">
              <option value="0">{{ $t("filter.common.status") }}</option>
              <option value="1">{{ $t("filter.membership.ok") }}</option>
              <option value="2">{{ $t("filter.membership.delete") }}</option>
              <option value="3">
                {{ $t("filter.membership.postpone") }}
              </option>
            </select>
          </div>
          <div>
            <select class="form-select-lg" v-model="searchData.searchtype">
              <option value="1">{{ $t("filter.common.location") }}</option>
              <option value="2">{{ $t("filter.common.id") }}</option>
              <option value="3">
                {{ $t("filter.membership.representative") }}
              </option>
              <option value="4">{{ $t("filter.membership.phone") }}</option>
            </select>
          </div>
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              v-model="searchData.searchname"
            />
            <button
              class="btn btn-primary btn-lg icon-search"
              type="submit"
              value=""
            ></button>
          </div>
        </div>
      </b-form>

      <table class="table board toggle-xxl">
        <thead>
          <tr>
            <th class="col-auto d-none d-xxl-table-cell">
              {{ $t("title.common.number") }}
            </th>
            <th class="col-auto d-none d-md-table-cell">
              {{ $t("title.membership.area") }}
            </th>
            <th class="col-auto">{{ $t("title.common.location") }}</th>
            <th class="col-auto">
              {{ $t("title.common.id") }}/{{ $t("title.common.password") }}
            </th>
            <th class="col-auto d-none d-xxl-table-cell">
              {{ $t("title.membership.representative") }}
            </th>
            <th class="col-auto d-none d-xxl-table-cell">
              {{ $t("title.membership.hittingbay_count") }}
            </th>
            <th class="col-auto d-none d-md-table-cell">
              {{ $t("title.membership.phone") }}
            </th>
            <th class="col-auto d-none d-xxl-table-cell">
              {{ $t("title.common.registration") }}
            </th>
            <th class="col-auto d-none d-xxl-table-cell">
              {{ $t("title.common.status") }}
            </th>
            <th class="th-arrow"></th>
          </tr>
        </thead>
        <tbody v-if="total_cnt > 0">
          <template v-for="(item, index) in items">
            <tr :key="index">
              <td class="col-auto d-none d-xxl-table-cell">
                {{ item.no }}
              </td>
              <td class="col-auto d-none d-md-table-cell">
                {{ item.searchnamearea }}
              </td>
              <td class="col-auto text-start text-md-center">
                <router-link
                  :to="{
                    name: 'OwnerEdit',
                    params: { ownerno: item.ownerno },
                  }"
                  class="shop-name d-flex align-items-start flex-column"
                >
                  <p class="badge bg-black" :class="{ 'bg-black' : item.platform_type === '0', 'bg-white' : item.platform_type === '1' }">
                    {{
                      item.platform_type === "0"
                        ? $t('text.common.online')
                        : item.platform_type === "1"
                        ? $t('text.common.offline')
                        : ""
                    }}
                  </p>
                  <p class="mt-2 more">{{ item.shopname }}</p>
                </router-link>
              </td>
              <td class="col-auto text-start text-md-center text-break">
                {{ item.id }} / {{ item.password }}
              </td>
              <td class="col-auto d-none d-xxl-table-cell">{{ item.name }}</td>
              <td class="col-auto d-none d-xxl-table-cell">
                <span @click="showModal(item.ownerno, 1)" class="more">
                  {{ item.roomcnt }}
                </span>
              </td>
              <td class="col-auto d-none d-md-table-cell">{{ item.phone }}</td>
              <td class="col-auto d-none d-xxl-table-cell text-date">
                {{ item.timezone_regdate | dateformat }}
              </td>
              <td class="col-auto d-none d-xxl-table-cell">
                <label
                  :class="{
                    'status-done px-2 text-uppercase': item.status === '1',
                    'status-drop px-2': item.status === '2',
                  }"
                >
                  {{ owner_status(item.status) }}
                </label>
              </td>
              <td class="td-arrow" @click="toggle_tr(index)">
                <img
                  src="/img/arrow_none_collapsed.png"
                  :class="{ 'btn-toggle-arrow': view_hide === index }"
                />
              </td>
            </tr>
            <tr
              class="d-xxl-none"
              :class="{ show: view_hide === index }"
              :key="index + 'r'"
              v-if="view_hide === index"
            >
              <td colspan="9">
                <div class="toggle-content">
                  <div class="row">
                    <div class="col-4">
                      {{ $t("title.common.number") }}
                    </div>
                    <div class="col-8">{{ item.no }}</div>
                  </div>
                  <div class="row d-md-none">
                    <div class="col-4">
                      {{ $t("title.membership.area") }}
                    </div>
                    <div class="col-8">{{ item.searchnamearea }}</div>
                  </div>
                  <div class="row">
                    <div class="col-4">
                      {{ $t("title.membership.representative") }}
                    </div>
                    <div class="col-8">{{ item.name }}</div>
                  </div>
                  <div class="row">
                    <div class="col-4">
                      {{ $t("title.membership.hittingbay_count") }}
                    </div>
                    <div class="col-8">
                      <span @click="showModal(item.ownerno, 1)" class="more">{{
                        item.roomcnt
                      }}</span>
                    </div>
                  </div>
                  <div class="row d-md-none">
                    <div class="col-4">
                      {{ $t("title.membership.phone") }}
                    </div>
                    <div class="col-8">{{ item.phone }}</div>
                  </div>
                  <div class="row">
                    <div class="col-4">
                      {{ $t("title.common.registration") }}
                    </div>
                    <div class="col-8 text-date">
                      {{ item.timezone_regdate | dateformat }}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-4">
                      {{ $t("title.common.status") }}
                    </div>
                    <div class="col-8">
                      <label
                        :class="{
                          'status-done px-2 text-uppercase':
                            item.status === '1',
                          'status-drop px-2': item.status === '2',
                        }"
                      >
                        {{ owner_status(item.status) }}
                      </label>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </template>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="9" class="text-center">
              {{ $t("text.common.no_data") }}
            </td>
          </tr>
        </tbody>
      </table>
      <b-pagination-nav
        :link-gen="linkGen"
        :number-of-pages="page_total"
        v-model="searchData.pageno"
        use-router
        :aria-label="$t('text.common.pagination')"
        v-if="page_total > 1"
        first-class="prev"
        prev-class="prev"
        next-class="next"
        last-class="next"
        hide-ellipsis
        limit="10"
      >
        <template #first-text>
          <i class="material-icons">keyboard_double_arrow_left</i>
        </template>
        <template #prev-text>
          <i class="material-icons">navigate_before</i>
        </template>
        <template #next-text>
          <i class="material-icons">navigate_next</i>
        </template>
        <template #last-text>
          <i class="material-icons">keyboard_double_arrow_right</i>
        </template>
        <template #page="{ page, active }">
          <div v-if="active">{{ page }}</div>
          <div v-else>{{ page }}</div>
        </template>
      </b-pagination-nav>

      <div class="btn-bottom-wrapper">
        <b-button
          size="xl"
          variant="primary"
          :aria-label="$t('button.common.write')"
          @click="$router.push({ name: 'OwnerWrite' })"
          >{{ $t("button.common.write") }}</b-button
        >
      </div>
    </div>

    <b-modal
      id="modal-sim-info"
      ref="modal-sim-info"
      size="lg"
      centered
      scrollable
      footer-class="btn-bottom-wrapper"
    >
      <template #modal-header>
        <h5 class="modal-title">
          {{ $t("page.membership.simulator_Information") }}
        </h5>
        <b-button
          variant="close"
          :aria-label="$t('button.common.close')"
          @click="$refs['modal-sim-info'].hide()"
        ></b-button>
      </template>
      <b-form>
        <input type="hidden" v-model="modal_form.apipk" />
        <div class="hor-type owners">
          <div class="row border-bottom border-top-dgray">
            <div class="col-lg-4 bg-light row align-items-center">
              <label class="d-table-cell">
                {{ $t("title.common.number") }}
              </label>
            </div>
            <div class="col-lg">
              <select
                class="form-select-lg"
                v-model="modal_form.roomno"
                @change="change_room"
              >
                <option
                  v-for="roomnum in room"
                  :value="roomnum"
                  :key="roomnum + 'rno'"
                >
                  {{ roomnum }}
                </option>
              </select>
            </div>
          </div>
          <div class="row border-bottom">
            <div class="col-lg-4 bg-light row align-items-center">
              <label class="d-table-cell">
                {{ $t("title.common.room_name") }}
              </label>
            </div>
            <div class="col-lg">
              <input
                type="text"
                :placeholder="$t('text.common.enter_room_name')"
                v-model="modal_form.roomname"
                required
              />
            </div>
          </div>
          <div class="row border-bottom">
            <div class="col-lg-4 bg-light row align-items-center">
              <label class="d-table-cell">
                {{ $t("title.membership.code") }}
              </label>
            </div>
            <div class="col-lg">
              <div class="sim-code">
                <input
                  type="text"
                  v-model="modal_form.maincode"
                  required
                  readonly
                />
                <div class="mx-1">-</div>
                <input
                  type="text"
                  placeholder="0000"
                  v-model="modal_form.subcode"
                  required
                  maxlength="4"
                />
                <div class="mx-1">-</div>
                <input
                  type="text"
                  placeholder="00000000"
                  v-model="modal_form.etccode"
                  required
                  maxlength="8"
                />
              </div>
              <p class="text-subscript mt-2">
                {{ $t("text.common.sim_code_eg") }}
              </p>
            </div>
          </div>
          <div class="row border-bottom">
            <div class="col-lg-4 bg-light row align-items-center">
              <label class="d-table-cell">
                {{ $t("title.membership.hwmodel") }}
              </label>
            </div>
            <div class="col-lg">
              <select
                class="form-select-lg d-inline-block"
                v-model="modal_form.hwmodelno"
                required="required"
              >
                <option
                  v-for="(item, index) in ownerroomhwlist"
                  :value="item.hwmodelno"
                  :key="index + 'hw'"
                >
                  {{ item.hwmodelname }}
                </option>
              </select>
            </div>
          </div>
          <div class="row border-bottom">
            <div class="col-lg-4 bg-light row align-items-center">
              <label class="d-table-cell">
                {{ $t("title.membership.swmodel") }}
              </label>
            </div>
            <div class="col-lg">
              <select
                class="form-select-lg d-inline-block"
                v-model="modal_form.swmodelno"
                required
              >
                <option
                  v-for="(item, index) in ownerroomswlist"
                  :value="item.swmodelno"
                  :key="index + 'sw'"
                >
                  {{ item.swmodelname }}
                </option>
              </select>
            </div>
          </div>
          <div class="row border-bottom">
            <div class="col-lg-4 bg-light row align-items-center">
              <label class="d-table-cell">
                {{ $t("title.membership.installdate") }}
              </label>
            </div>
            <div class="col-lg">
              <input
                type="date"
                class="pe-0"
                placeholder="2021-12-25"
                v-model="modal_form.installdate"
              />
            </div>
          </div>

          <div class="row border-bottom">
            <div class="col-lg-4 bg-light row align-items-center">
              <label class="d-table-cell">
                {{ $t("title.common.status") }}
              </label>
            </div>
            <div class="col-lg">
              <select class="" v-model="modal_form.roomstatus">
                <option value="1">
                  {{ $t("filter.common.available") }}
                </option>
                <option value="2">
                  {{ $t("filter.common.unavailable") }}
                </option>
                <!-- <option value="3">Using</option> -->
              </select>
            </div>
          </div>
          <div class="row border-bottom">
            <div class="col-lg-4 bg-light row align-items-center">
              <label class="d-table-cell">
                {{ $t("title.membership.token") }}
              </label>
            </div>
            <div class="col-lg">
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  :placeholder="$t('text.common.enter_token_name')"
                  v-model="modal_form.token"
                  required
                />
                <button
                  type="button"
                  class="btn btn-lg icon-edit"
                  @click="token_check(modal_form)"
                ></button>
              </div>
            </div>
          </div>
          <div class="row border-bottom">
            <div class="col-lg-4 bg-light row align-items-center">
              <label class="d-table-cell">
                <span class="d-inline-block">
                  {{ $t("title.membership.expdate") }}</span
                >
              </label>
            </div>
            <div class="col-lg">
              <input
                type="date"
                class="pe-0"
                v-model="modal_form.expdate"
                required
              />
            </div>
          </div>
        </div>
      </b-form>
      <template #modal-footer>
        <b-button
          type="button"
          class="btn btn-outline-secondary btn-md"
          @click="hideModal"
        >
          {{ $t("button.common.close") }}
        </b-button>
        <b-button
          type="button"
          class="btn btn-secondary btn-md"
          @click="onRoomSubmit"
        >
          {{ $t("button.common.write") }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import ax from "@/api/member";
import { myMixin } from "@/mixin/myMixin";

export default {
  name: "OwnerList",
  data() {
    return {
      searchData: {
        platform_type:
          this.$route.query.platform_type ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].platform_type) ||
          "",
        ownertype:
          this.$route.query.ownertype ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].ownertype) ||
          0,
        status:
          this.$route.query.status ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].status) ||
          0,
        searchtype:
          this.$route.query.searchtype ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].searchtype) ||
          1,
        searchname:
          this.$route.query.searchname ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].searchname) ||
          "",
        pageno:
          this.$route.query.pageno ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].pageno) ||
          1,
      },
      page_total: 1,
      total_cnt: 0,
      data_yn: true,
      rows: 10,
      items: [],
      view_hide: null,
      modal_form: [
        {
          ownerno: "",
          roomcnt: 0,
          roomno: "",
          roomname: "",
          maincode: "",
          subcode: "",
          etccode: "",
          hwmodelno: 1,
          swmodelno: 1,
          installdate: "",
          roomstatus: "",
          apipk: 0,
          token: "",
          expdate: this.$dayjs(new Date()).add(1, "year").format("YYYY-MM-DD"),
        },
      ],
      ownerroomhwlist: [],
      ownerroomswlist: [],
      room: [],
      room_type: "write",
    };
  },
  watch: {
    "searchData.platform_type": function () {
      this.searchData.pageno = 1;
      this.get_adminownerlist();
    },
    "searchData.ownertype": function () {
      this.searchData.pageno = 1;
      this.get_adminownerlist();
    },
    "searchData.status": function () {
      this.searchData.pageno = 1;
      this.get_adminownerlist();
    },
    "searchData.searchtype": function () {
      this.searchData.pageno = 1;
      this.get_adminownerlist();
    },
    "searchData.searchname": function () {
      this.searchData.pageno = 1;
      this.get_adminownerlist();
    },
    "searchData.pageno": function () {
      this.get_adminownerlist();
    },
  },
  methods: {
    onSubmit(event) {
      event.preventDefault();
      this.searchData.pageno = 1;

      this.$store.commit("setSearchData", {
        [this.$route.name]: this.searchData,
      });
      this.get_adminownerlist();
    },
    get_adminownerlist() {
      this.$store.commit("setSearchData", {
        [this.$route.name]: this.searchData,
      });
      ax.get_adminownerlist(this.searchData, (flag, data, code) => {
        this.total_cnt = data.ownerlistcnt;
        this.page_total = Math.ceil(data.ownerlistcnt / this.rows);
        this.items = data.ownerlist;
        if (flag) {
          //console.log(this.items);
        } else {
          alert(data);
        }
      });
    },
    linkGen(pageNum) {
      return `?page=${pageNum}`;
    },
    toggle_tr(index) {
      if (this.view_hide === index) this.view_hide = null;
      else this.view_hide = index;
    },
    showModal(ownerno, roomno) {
      ax.get_adminownerroominfo(ownerno, roomno, (flag, data) => {
        if (flag) {
          this.modal_form = data.ownerroominfo;
          this.modal_form.installdate = this.modal_form.timezone_installdate
            ? this.$dayjs(this.modal_form.timezone_installdate).format(
                "YYYY-MM-DD"
              )
            : this.$dayjs(new Date()).format("YYYY-MM-DD");
          this.room = [];
          if (this.modal_form.roomname != null) this.room_type = "edit";
          else this.room_type = "write";

          for (let i = 0; i < this.modal_form.roomcnt; i++) {
            this.room.push(i + 1);
          }
          ax.get_adminownerhwlist((flag, data) => {
            if (flag) {
              this.ownerroomhwlist = data.ownerhwlist;
            }
          });
          ax.get_adminownerswlist((flag, data) => {
            if (flag) {
              this.ownerroomswlist = data.ownerswlist;
            }
          });

          this.modal_form.simulator_pk = this.modal_form.simulator_pk || 0;
          this.modal_form.api_pk = this.modal_form.api_pk || 0;
          this.modal_form.token = this.modal_form.token || "";

          this.modal_form.expdate = this.modal_form.timezone_expdate
            ? this.$dayjs(this.modal_form.timezone_expdate).format("YYYY-MM-DD")
            : this.$dayjs(new Date()).add(1, "year").format("YYYY-MM-DD");
        } else {
          alert(data);
          return false;
        }
      });
      //this.$refs["modal-sim-info"].modalOuterStyle.zIndex = 9999;
      this.$refs["modal-sim-info"].show();
    },
    hideModal() {
      this.$refs["modal-sim-info"].hide();
    },
    change_room(event) {
      console.log(this.modal_form.ownerno, event.target.value);
      if (!this.modal_form.ownerno) return false;
      this.showModal(this.modal_form.ownerno, event.target.value);
    },
    onRoomSubmit(event) {
      event.preventDefault();

      // if (this.modal_form.token === "") {
      //   alert(
      //     this.$i18n.t("alert.common.field_enter", {
      //       field: this.$i18n.t("title.membership.token"),
      //     })
      //   );

      //   return false;
      // }

      if (this.room_type === "write") {
        ax.set_adminownerroomewrite(this.modal_form, (flag, data) => {
          if (flag) {
            alert(data.message);
            this.hideModal();
          } else {
            alert(data.message);
          }
        });
      } else if (this.room_type === "edit") {
        ax.set_adminownerroomedit(this.modal_form, (flag, data) => {
          if (flag) {
            alert(data.message);
            this.hideModal();
          } else {
            alert(data.message);
          }
        });
      }
    },
    token_check(modal_form) {
      if (modal_form.token === "") {
        alert(
          this.$i18n.t("alert.common.field_enter", {
            field: this.$i18n.t("title.membership.token"),
          })
        );
        return false;
      }
      ax.token_check(modal_form, (flag, data) => {
        alert(data.message);
      });
    },
  },
  mounted() {
    this.get_adminownerlist();
  },

  mixins: [myMixin],
};
</script>
